var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.currentTab
    ? _c(
        "div",
        { staticClass: "t-nav", class: { "t-nav--collapsed": _vm.$isMobile } },
        [
          _c(
            "div",
            {
              staticClass: "t-nav__header",
              class: { "t-mar--r-lg": !_vm.partnerMode && !_vm.$isMobile },
            },
            [
              _vm.partnerMode
                ? _c(
                    "router-link",
                    { staticClass: "t-dis--in-blk", attrs: { to: "/" } },
                    [
                      !_vm.$isMobile
                        ? _c("img", {
                            attrs: {
                              src: require(`@/lib/assets/images/partner/${_vm.partnerId}/logo.svg`),
                              height: "30px",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: require(`@/lib/assets/images/partner/${_vm.partnerId}/icon.svg`),
                              height: "30px",
                            },
                          }),
                    ]
                  )
                : _c(
                    "router-link",
                    { staticClass: "t-dis--in-blk", attrs: { to: "/" } },
                    [
                      !_vm.$isMobile
                        ? _c("img", {
                            attrs: {
                              src: require("@/lib/assets/images/cb-trainn-logo.svg"),
                              height: "48px",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/lib/assets/images/Trainn-Logo-Assets/SVG/Trainn-logo-blue.svg"),
                              height: "30px",
                            },
                          }),
                    ]
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "t-nav__main" }, [
            _c(
              "div",
              { staticClass: "t-nav__tabs t-pad--t-mi" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "t-nav__tab",
                    class: {
                      "t-nav__tab--active":
                        _vm.currentTab == _vm.tabs.dashboard,
                    },
                    attrs: { to: "/dashboard" },
                  },
                  [
                    _c("i", {
                      staticClass:
                        "t-nav__icon mdi mdi-monitor-dashboard mdi-21px",
                    }),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("nav.tab.dashboard"))),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "'t-nav__tab-wrap" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "t-nav__tab",
                        attrs: { to: "/library" },
                        on: {
                          click: function ($event) {
                            return _vm.toggleLibrary()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "t-nav__icon mdi mdi-animation-play mdi-21px",
                        }),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("nav.tab.library"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.expandLibrary && !_vm.$isMobile
                          ? _c("i", {
                              staticClass:
                                "t-nav__icon mdi mdi-chevron-down mdi-21px",
                            })
                          : !_vm.$isMobile
                          ? _c("i", {
                              staticClass:
                                "t-nav__icon mdi mdi-chevron-up mdi-21px",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("t-slide", [
                      _vm.expandLibrary
                        ? _c(
                            "div",
                            { staticClass: "t-nav__subtabs" },
                            _vm._l(
                              _vm.$user.workspace.spaces,
                              function (space) {
                                return _c(
                                  "router-link",
                                  {
                                    key: space.id,
                                    staticClass: "t-nav__subtab",
                                    class: [
                                      {
                                        "t-nav__tab--active":
                                          _vm.rootFolderId == space.id,
                                      },
                                    ],
                                    attrs: { to: `/library/${space.id}` },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(space.title) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.appEmbedsEnabled
                  ? _c(
                      "div",
                      { staticClass: "'t-nav__tab-wrap" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "t-nav__tab",
                            class: [
                              {
                                "t-nav__tab--active":
                                  _vm.currentTab == _vm.tabs.embed &&
                                  !_vm.showEmbedSubTab,
                              },
                              {
                                "t-disabled-opacity t-cursor--not-allow":
                                  _vm.$isMobile,
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.toggleEmbed()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "t-nav__icon mdi mdi-cursor-default-click mdi-21px",
                            }),
                            _vm._v(" "),
                            !_vm.$isMobile
                              ? _c("span", [_vm._v("In-App Tutorials")])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.showEmbedSubTab && !_vm.$isMobile
                              ? _c("i", {
                                  staticClass:
                                    "t-nav__icon mdi mdi-chevron-down mdi-21px",
                                })
                              : !_vm.$isMobile
                              ? _c("i", {
                                  staticClass:
                                    "t-nav__icon mdi mdi-chevron-up mdi-21px",
                                })
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("t-slide", [
                          _vm.showEmbedSubTab
                            ? _c(
                                "div",
                                { staticClass: "t-nav__subtabs" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "t-nav__subtab",
                                      class: [
                                        {
                                          "t-nav__subtab--active":
                                            _vm.subTab == "embeds_home",
                                        },
                                      ],
                                      attrs: { to: { name: "embeds_home" } },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Builder\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "t-nav__subtab",
                                      class: [
                                        {
                                          "t-nav__subtab--active":
                                            _vm.subTab ==
                                            "embeds_configuration",
                                        },
                                      ],
                                      attrs: {
                                        to: { name: "embeds_configuration" },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Configuration\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "t-nav__tab",
                    class: {
                      "t-nav__tab--active":
                        _vm.currentTab == _vm.tabs.collections,
                    },
                    attrs: { to: "/collections" },
                  },
                  [
                    _c("i", {
                      staticClass:
                        "t-nav__icon mdi mdi-view-dashboard mdi-21px",
                    }),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("nav.tab.learning_path"))),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "'t-nav__tab-wrap" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "t-nav__tab",
                        class: [
                          {
                            "t-nav__tab--active":
                              _vm.currentTab == _vm.tabs.hub &&
                              !_vm.showVideoHubSubTab,
                          },
                          {
                            "t-disabled-opacity t-cursor--not-allow":
                              _vm.$isMobile,
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.toggleVideoHub()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "t-nav__icon mdi mdi-library mdi-21px",
                        }),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("nav.tab.hub")))])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showVideoHubSubTab && !_vm.$isMobile
                          ? _c("i", {
                              staticClass:
                                "t-nav__icon mdi mdi-chevron-down mdi-21px",
                            })
                          : !_vm.$isMobile
                          ? _c("i", {
                              staticClass:
                                "t-nav__icon mdi mdi-chevron-up mdi-21px",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("t-slide", [
                      _vm.showVideoHubSubTab
                        ? _c(
                            "div",
                            { staticClass: "t-nav__subtabs" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "hub_analytics",
                                    },
                                  ],
                                  attrs: { to: "/hub/analytics" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("hub.analytics.title")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !_vm.canUpdateVideoHub && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "!canUpdateVideoHub && { content: $t('message.no_access'), offset: 8,}",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "hub_builder",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !(
                                          _vm.$user.can("update", "course") ||
                                          _vm.$user.can("update", "academy")
                                        ),
                                    },
                                  ],
                                  attrs: {
                                    to: (_vm.canUpdateVideoHub && "/hub") || "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("hub.builder.title")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "'t-nav__tab-wrap" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "t-nav__tab",
                        class: [
                          {
                            "t-nav__tab--active":
                              _vm.currentTab == _vm.tabs.academy &&
                              !_vm.showAcademySubTab,
                          },
                          {
                            "t-disabled-opacity t-cursor--not-allow":
                              _vm.$isMobile,
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.toggleAcademy()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "t-nav__icon mdi mdi-school mdi-21px",
                        }),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("nav.tab.academy"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showAcademySubTab && !_vm.$isMobile
                          ? _c("i", {
                              staticClass:
                                "t-nav__icon mdi mdi-chevron-down mdi-21px",
                            })
                          : !_vm.$isMobile
                          ? _c("i", {
                              staticClass:
                                "t-nav__icon mdi mdi-chevron-up mdi-21px",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("t-slide", [
                      _vm.showAcademySubTab
                        ? _c(
                            "div",
                            { staticClass: "t-nav__subtabs" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "academy_home",
                                    },
                                  ],
                                  attrs: { to: "/academy" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.academy_home")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !(
                                        _vm.$user.can("update", "course") ||
                                        _vm.$user.can("update", "academy")
                                      ) && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "!($user.can('update', 'course') || $user.can('update', 'academy')) && {\n                           content: $t('message.no_access'),\n                           offset: 8,\n                         }\n                         ",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "course_builder",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !(
                                          _vm.$user.can("update", "course") ||
                                          _vm.$user.can("update", "academy")
                                        ),
                                    },
                                  ],
                                  attrs: {
                                    to:
                                      ((_vm.$user.can("update", "course") ||
                                        _vm.$user.can("update", "academy")) &&
                                        "/academy/courses") ||
                                      "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.course_builder")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !(
                                        _vm.$user.can("update", "course") ||
                                        _vm.$user.can("update", "academy")
                                      ) && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "!($user.can('update', 'course') || $user.can('update', 'academy')) && {\n                           content: $t('message.no_access'),\n                           offset: 8,\n                         }\n                         ",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "academy_builder",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !(
                                          _vm.$user.can("update", "course") ||
                                          _vm.$user.can("update", "academy")
                                        ),
                                    },
                                  ],
                                  attrs: {
                                    to:
                                      _vm.$user.can("update", "academy") &&
                                      _vm.academyBuilderUrl,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.academy_builder")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !_vm.$user.can(
                                        "update",
                                        "academy"
                                      ) && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "!$user.can('update', 'academy') && {\n                           content: $t('message.no_access'),\n                           offset: 8,\n                         }\n                         ",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "academy_config",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !_vm.$user.can("update", "academy"),
                                    },
                                  ],
                                  attrs: {
                                    to:
                                      (_vm.$user.can("update", "academy") &&
                                        "/academy/configurations") ||
                                      "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.academy_config")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !_vm.$user.can(
                                        "update",
                                        "training_event"
                                      ) && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "!($user.can('update', 'training_event')) && {\n                           content: $t('message.no_access'),\n                           offset: 8,\n                         }\n                         ",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "academy_events",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !_vm.$user.can(
                                          "update",
                                          "training_event"
                                        ),
                                    },
                                  ],
                                  attrs: {
                                    to:
                                      (_vm.$user.can(
                                        "update",
                                        "training_event"
                                      ) &&
                                        "/academy/events") ||
                                      "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.academy_events")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "t-nav__tab",
                    class: {
                      "t-nav__tab--active": _vm.currentTab == _vm.tabs.learners,
                    },
                    attrs: { to: "/learners" },
                  },
                  [
                    _c("i", {
                      staticClass: "t-nav__icon mdi mdi-account mdi-21px",
                    }),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("nav.tab.learners")))])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "t-nav__tab",
                    class: {
                      "t-nav__tab--active":
                        _vm.currentTab == _vm.tabs.learnerGroup,
                    },
                    attrs: { to: "/learner_groups" },
                  },
                  [
                    _c("i", {
                      staticClass: "t-nav__icon mdi mdi-account-group mdi-21px",
                    }),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("nav.tab.learner_group"))),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.$user.can("update", "email_setting")
                  ? _c(
                      "router-link",
                      {
                        staticClass: "t-nav__tab",
                        class: [
                          {
                            "t-nav__tab--active":
                              _vm.currentTab == _vm.tabs.emails,
                          },
                        ],
                        attrs: { to: "/emails/settings" },
                      },
                      [
                        _c("i", {
                          staticClass: "t-nav__icon mdi mdi-email mdi-21px",
                        }),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("nav.tab.email"))),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.partnerMode
                  ? _c(
                      "router-link",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: !_vm.$user.can("update", "workspace") && {
                              content: _vm.$t("message.no_access"),
                              offset: 8,
                            },
                            expression:
                              "!$user.can('update', 'workspace') && {\n                     content: $t('message.no_access'),\n                     offset: 8,\n                   }\n                   ",
                          },
                        ],
                        staticClass: "t-nav__tab",
                        class: [
                          {
                            "t-nav__tab--active":
                              _vm.currentTab == _vm.tabs.integrations,
                          },
                          {
                            "t-disabled-opacity t-cursor--not-allow":
                              !_vm.$user.can("update", "workspace"),
                          },
                        ],
                        attrs: {
                          to: _vm.$user.can("update", "workspace")
                            ? "/integrations"
                            : "",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "t-nav__icon mdi mdi-puzzle mdi-21px",
                        }),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("nav.tab.integrations"))),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "t-nav__aside" }, [
            _c(
              "div",
              { staticClass: "t-nav__actions" },
              [
                _c(
                  "div",
                  { staticClass: "t-nav__action t-flex t-flex--jcsb" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "t-flex t-flex--aic",
                        on: { click: _vm.openLearningCenter },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "t-nav__icon mdi mdi-help-circle-outline mdi-18px",
                        }),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", { staticClass: "t-mar--r-mi" }, [
                              _vm._v(" Help Centre "),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$t("nav.actions.new"),
                            expression: "$t('nav.actions.new')",
                          },
                        ],
                        staticClass: "t-pos--rel",
                        attrs: {
                          href: "https://help.trainn.co/uwzNgv9RU8k-feature-enhancements/QUeAkmRcR4g-set-up-video-brand-styles?utm_source=what%27s_new",
                          target: "_blank",
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "t-nav__icon t-tc--dark mdi mdi-gift mdi-18px",
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  { staticClass: "t-nav__action", attrs: { to: "/settings" } },
                  [
                    _c("i", {
                      staticClass: "t-nav__icon mdi mdi-cog-outline mdi-18px",
                    }),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c(
                          "span",
                          { staticClass: "t-mar--r-mi t-clamp t-clamp--line" },
                          [
                            _vm._v(
                              _vm._s(_vm.workspace.displayName) + " Settings "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.$user.can("update", "workspace")
                  ? _c(
                      "router-link",
                      {
                        staticClass: "t-nav__action",
                        attrs: { to: "/settings/members" },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "t-nav__icon mdi mdi-account-plus-outline mdi-18px",
                        }),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", { staticClass: "t-mar--r-mi" }, [
                              _vm._v(" Invite Members "),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "t-nav__create t-pos--rel" },
              [
                _c(
                  "t-button",
                  {
                    attrs: {
                      variant: "primary",
                      tooltip:
                        (!_vm.$user.can("create", "video") &&
                          _vm.$t("message.no_access")) ||
                        "",
                      fluid: "",
                      disabled: !_vm.$user.can("create", "video"),
                      size: "xsmall",
                    },
                    on: { click: _vm.toggleMenu },
                  },
                  [
                    _vm.$isMobile
                      ? [
                          _c("i", {
                            staticClass: "mdi mdi-motion-play mdi-21px",
                          }),
                        ]
                      : [_c("span", [_vm._v("Create")])],
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.showMenu
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "t-popover t-popover--sleek t-popover--sm t-mar--t-no t-popover--top",
                        },
                        [
                          _c("div", { staticClass: "t-popover__list" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value:
                                      !_vm.$user.eligible(
                                        "walk_through_videos"
                                      ) && _vm.$t("recorder.recording_blocked"),
                                    expression:
                                      "!$user.eligible('walk_through_videos') && $t('recorder.recording_blocked')",
                                  },
                                ],
                                staticClass: "t-popover__item",
                                class: {
                                  "t-popover__item--disabled":
                                    !_vm.$user.can("create", "video") ||
                                    !_vm.$user.eligible("walk_through_videos"),
                                },
                                on: { click: _vm.openCreateModal },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "mdi mdi-motion-play mdi-21px t-mar--r-ti",
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("nav.button.create"))),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value:
                                      !_vm.$user.eligible("guides") &&
                                      _vm.$t("recorder.recording_blocked"),
                                    expression:
                                      "!$user.eligible('guides') && $t('recorder.recording_blocked')",
                                  },
                                ],
                                staticClass: "t-popover__item",
                                class: {
                                  "t-popover__item--disabled":
                                    !_vm.$user.can("create", "guide") ||
                                    !_vm.$user.eligible("guides"),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.createInteractiveGuide()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "mdi mdi-gesture-double-tap mdi-21px t-mar--r-ti",
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "t-mar--r-ti" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("generic.button.create_guide")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "t-popover__item",
                                class: {
                                  "t-disabled t-cursor--not-allow": _vm.loading,
                                },
                                on: { click: _vm.createArticle },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "mdi mdi-text-box-outline mdi-21px t-mar--r-ti",
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("generic.button.new_article"))
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "t-popover__item",
                                on: {
                                  click: function ($event) {
                                    return _vm.openDocumentUploadModal()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "mdi mdi-file-document-outline mdi-21px t-mar--r-ti",
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("generic.button.upload_document")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }